<template>
  <LoadingWrapper :state="status">
    <div class="flex flex-col gap-6">
      <section class="flex flex-col gap-1">
        <h2 class="text-title-medium text-on-surface-variant">
          {{ t('lumia.lesson.myCountRunning', { count: runningLessons.length }) }}
        </h2>
        <ul v-if="runningLessons.length" class="grid grid-cols-1 gap-0.5">
          <li
            v-for="lesson in runningLessons"
            :key="lesson.id"
            class="bg-surface-container-lowest first:rounded-t-large last:rounded-b-large rounded-extra-small overflow-hidden"
          >
            <LessonListItem :lesson="lesson" />
          </li>
        </ul>
        <p v-else class="text-body-large text-on-surface-variant">
          {{ t('lumia.lesson.empty.runningTitle') }}
        </p>
      </section>
      <section class="flex flex-col gap-1">
        <h2 class="text-title-medium text-on-surface-variant">
          {{ t('lumia.lesson.endedCount', { count: endedLessons.length }) }}
        </h2>
        <ul v-if="endedLessons.length" class="grid grid-cols-1 gap-0.5">
          <li
            v-for="lesson in endedLessons"
            :key="lesson.id"
            class="bg-surface-container first:rounded-t-large last:rounded-b-large rounded-extra-small overflow-hidden"
          >
            <LessonListItem :lesson="lesson" on-container />
          </li>
        </ul>
        <p v-else class="text-body-large text-on-surface-variant">
          {{ t('lumia.lesson.empty.endedTitle') }}
        </p>
      </section>
    </div>
  </LoadingWrapper>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useLessons } from '../composables/use-lessons'
  import LessonListItem from './LessonListItem.vue'

  const props = defineProps<{
    teamId: string
  }>()

  const { t } = useI18n()
  const teamId = computed(() => props.teamId)

  const { lessons: lessons, status } = useLessons({
    teamId,
  })

  const runningLessons = computed(
    () => lessons.value.filter((lesson) => lesson.endedAt === null) ?? [],
  )
  const endedLessons = computed(
    () => lessons.value.filter((lesson) => lesson.endedAt !== null) ?? [],
  )
</script>
